import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { Backoffice } from './backoffice/Backoffice';
import { CAIXA_WINDOW, GESTAO_WINDOW, switchTo } from './lib/windows';
import './styles.css';

// Tema: o do sistema, salvo escolha guardada na própria caixa.
const theme = (() => { try { return localStorage.getItem('makila-pos-theme'); } catch { return null; } })();
if (theme === 'dark' || (!theme && matchMedia('(prefers-color-scheme: dark)').matches)) document.documentElement.classList.add('dark');

// A aplicação fica no dispositivo (abre sem internet). Só em produção: em
// desenvolvimento o Vite serve tudo e a cache só atrapalhava.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.register('/sw.js').then((reg) => {
    // Versão nova à espera → avisa a aplicação (botão "Actualizar", ver lib/update.ts).
    const announce = () => { if (reg.waiting && navigator.serviceWorker.controller) dispatchEvent(new CustomEvent('pos-update-ready', { detail: reg.waiting })); };
    announce();
    reg.addEventListener('updatefound', () => reg.installing?.addEventListener('statechange', announce));
    setInterval(() => void reg.update().catch(() => {}), 30 * 60_000);
  });
  // Depois de aceitar a versão nova, recarrega uma vez para a usar. Só quando
  // uma versão substitui outra: na primeira instalação o SW também "toma
  // conta" da página, e recarregar aí apagava a sessão da gestão a meio.
  const hadController = !!navigator.serviceWorker.controller;
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => { if (hadController && !reloaded) { reloaded = true; location.reload(); } });
}

const root = createRoot(document.getElementById('root')!);

/**
 * Uma caixa = um separador. Dois separadores a vender no mesmo terminal
 * disputariam a numeração local; o segundo fica parado com um aviso.
 */
function start() {
  root.render(<StrictMode><App /></StrictMode>);
}

if (location.pathname.startsWith('/gestao')) {
  // Gestão: não é uma caixa (sem lock de terminal nem base de dados local).
  window.name = GESTAO_WINDOW;
  root.render(<StrictMode><Backoffice /></StrictMode>);
} else if ('locks' in navigator) {
  void navigator.locks.request('makila-pos-terminal', { ifAvailable: true }, async (lock) => {
    if (!lock) {
      root.render(
        <div className="grid h-full place-items-center p-6 text-center">
          <div>
            <h1 className="text-2xl font-bold">A caixa já está aberta noutro separador</h1>
            <p className="mt-2 text-muted">Use esse separador, ou feche-o e recarregue este.</p>
            <button onClick={() => switchTo('/gestao')} className="mt-6 h-11 rounded-xl border border-base px-4 font-medium">Abrir a gestão</button>
          </div>
        </div>,
      );
      return;
    }
    window.name = CAIXA_WINDOW;
    start();
    await new Promise(() => {}); // segura o lock enquanto a página estiver aberta
  });
} else {
  start();
}
